import { useMutateGetFile } from "@/api/s3.api";
import { useState } from "react";

/**
 * Downloads a single S3 file via a presigned URL and triggers a browser save.
 */
export const useDownloadFile = () => {
  const { mutateAsync: getFile } = useMutateGetFile();
  const [isDownloading, setIsDownloading] = useState(false);

  const downloadFile = async (path: string, filename: string) => {
    setIsDownloading(true);
    try {
      const url = await getFile(path);
      const response = await fetch(url);
      const blob = await response.blob();
      const blobUrl = URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(blobUrl);
    } finally {
      setIsDownloading(false);
    }
  };

  return { downloadFile, isDownloading };
};
